import { Box, Typography } from "@mui/material";
import CircleCrossIcon from "../../../../assets/svg-fc/CircleCrossIcon";
import DeleteIcon from "../../../../assets/svg-fc/DeleteIcon";
import PdfFileIcon from "../../../../assets/svg-fc/PdfFileIcon";
import TickCircleIcon from "../../../../assets/svg-fc/TickCircleIcon";
import IsMobile from "../../../../hooks/isMobile";
import "./uploadPdfCard.scss";

interface UploadPdfCardProps {
	pdfFile: File;
	progress: number;
	loading: boolean;
	onCancelUpload: () => void;
	onRemoveFile: () => void;
}

const UploadPdfCard = ({ pdfFile, progress, loading, onCancelUpload, onRemoveFile }: UploadPdfCardProps) => {
	const isMobile = IsMobile();
	const fileSizeInKB = Math.round((pdfFile?.size || 0) / 1024);
	const uploadedSizeInKB = Math.round(
		((progress < 5 ? 0 : progress < 14 ? 30 : progress < 19 ? 70 : 100) / 100) * fileSizeInKB,
	);

	return (
		<Box className="pdfFileUploadSection">
			<Box className="pdfFileHeader">
				<PdfFileIcon width="32" height="32" />
				<Box className="pdfFileInfo">
					<Typography className="pdfFileName">{pdfFile?.name}</Typography>
					<Box className="uploadProgressInfo">
						<Typography className="progressText">
							{`${uploadedSizeInKB} KB of ${fileSizeInKB} KB •`}
						</Typography>
						<Box className="uploadStatus">
							{loading ? <Box className="spinner" /> : <TickCircleIcon />}
							<Typography className="statusText">
								{progress < 19
									? "Uploading"
									: progress < 55
										? "Analyzing"
										: progress < 100
											? "Extracting"
											: isMobile
												? "Imported"
												: "Import Complete"}
							</Typography>
						</Box>
					</Box>
				</Box>
				{loading ? (
					<Box className="closeButton" onClick={onCancelUpload}>
						<CircleCrossIcon />
					</Box>
				) : (
					<Box className="closeButton delete" onClick={onRemoveFile}>
						<DeleteIcon />
					</Box>
				)}
			</Box>
			{loading && (
				<Box className="progressBarContainer">
					<Box className="progressBar">
						<Box className="progressFill" style={{ width: `${progress}%` }} />
					</Box>
				</Box>
			)}
		</Box>
	);
};

export default UploadPdfCard;
